import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export type BadgeTone =
  | "neutral"
  | "success"
  | "warning"
  | "danger"
  | "info"
  | "ocean";

interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  className?: string;
}

const TONE_CLASSES: Record<BadgeTone, string> = {
  neutral: "border-neutral-200 bg-neutral-100 text-neutral-700",
  success: "border-success-600/30 bg-success-50 text-success-600",
  warning: "border-warning-600/30 bg-warning-50 text-warning-600",
  danger: "border-danger-600/30 bg-danger-50 text-danger-600",
  info: "border-info-600/30 bg-info-50 text-info-600",
  ocean: "border-ocean-200 bg-ocean-50 text-ocean-800",
};

export function Badge({ children, tone = "neutral", className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium",
        TONE_CLASSES[tone],
        className
      )}
    >
      {children}
    </span>
  );
}
